var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.02002,
    width: 26,
    height: 26,
    rx: 7,
    fill: "#E8F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24783 7.65045C9.24783 8.55111 8.52391 9.28089 7.63043 9.28089C6.73696 9.28089 6.01304 8.55111 6.01304 7.65045C6.01304 6.75045 6.73696 6.02002 7.63043 6.02002C8.52391 6.02002 9.24783 6.75045 9.24783 7.65045ZM9.26087 10.5852H6V21.02H9.26087V10.5852ZM14.4665 10.5852H11.2265V21.02H14.4672V15.5424C14.4672 12.4968 18.3991 12.2476 18.3991 15.5424V21.02H21.6522V14.4128C21.6522 9.27372 15.8335 9.46089 14.4665 11.9907V10.5852Z",
    fill: "#202D2D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.02002,
    width: 26,
    height: 26,
    rx: 7,
    stroke: "#374646",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.f8dd71ca64b95086a1fd99d1d55458e7.svg";
export { ForwardRef as ReactComponent };